import _inherits from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { EncryptedDataKey } from './encrypted_data_key';
import { immutableBaseClass, immutableClass } from './immutable_class';
import { isEncryptionMaterial, isDecryptionMaterial } from './cryptographic_material';
import { needs } from './needs';
/*
 * This public interface to the Keyring object is provided for
 * developers of CMMs and keyrings only. If you are a user of the AWS Encryption
 * SDK and you are not developing your own CMMs and/or keyrings, you do not
 * need to use it and you should not do so.
 */

export var Keyring = /*#__PURE__*/function () {
  function Keyring() {
    _classCallCheck(this, Keyring);
  }

  _createClass(Keyring, [{
    key: "onEncrypt",
    value: function () {
      var _onEncrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(material) {
        var _material;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /* Precondition: material must be a type of isEncryptionMaterial.
                 * There are several security properties that NodeEncryptionMaterial and WebCryptoEncryptionMaterial
                 * posses.
                 * The unencryptedDataKey can only be written once.
                 * If a data key has not already been generated, there must be no EDKs.
                 * See cryptographic_materials.ts
                 */
                needs(isEncryptionMaterial(material), 'Unsupported type of material.');
                _context.next = 3;
                return this._onEncrypt(material);

              case 3:
                _material = _context.sent;

                /* Postcondition: The EncryptionMaterial objects must be the same.
                 * See cryptographic_materials.ts.  The CryptographicMaterial objects
                 * provide several security properties, including immutability of
                 * the unencrypted data key and the ability to zero the data key.
                 * This is insured by returning the same material.
                 */
                needs(material === _material, 'New EncryptionMaterial instances can not be created.');
                /* Postcondition UNTESTED: If this keyring generated data key, it must be the right length.
                 * See cryptographic_materials.ts This is handled in setUnencryptedDataKey
                 * this condition is listed here to keep help keep track of important conditions
                 */

                return _context.abrupt("return", material);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onEncrypt(_x) {
        return _onEncrypt.apply(this, arguments);
      }

      return onEncrypt;
    }()
    /* NOTE: The order of EDK's passed to the onDecrypt function is a clear
     * intent on the part of the person who did the encryption.
     * The EDK's should always correspond to the order serialized.
     * It is the Keyrings responsibility to maintain this order.
     * The most clear example is from KMS.  KMS is a regional service.
     * This means that a call to decrypt an EDK must go to the
     * region that "owns" this EDK.  If the decryption is done
     * in a different region. To control this behavior the person
     * who called encrypt can control the order of EDK and in the
     * configuration of the KMS Keyring.
     */

  }, {
    key: "onDecrypt",
    value: function () {
      var _onDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(material, encryptedDataKeys) {
        var _material;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /* Precondition: material must be DecryptionMaterial. */
                needs(isDecryptionMaterial(material), 'Unsupported material type.');
                /* Precondition: Attempt to decrypt iif material does not have an unencrypted data key. */

                if (!material.hasValidKey()) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", material);

              case 3:
                /* Precondition: encryptedDataKeys must all be EncryptedDataKey. */
                needs(encryptedDataKeys.every(function (edk) {
                  return edk instanceof EncryptedDataKey;
                }), 'Unsupported EncryptedDataKey type');
                _context2.next = 6;
                return this._onDecrypt(material, encryptedDataKeys);

              case 6:
                _material = _context2.sent;

                /* Postcondition: The DecryptionMaterial objects must be the same.
                 * See cryptographic_materials.ts.  The CryptographicMaterial objects
                 * provide several security properties, including immutability of
                 * the unencrypted data key and the ability to zero the data key.
                 * This is insured by returning the same material.
                 */
                needs(material === _material, 'New DecryptionMaterial instances can not be created.');
                /* See cryptographic_materials.ts The length condition is handled there.
                 * But the condition is important and so repeated here.
                 * The postcondition is "If an EDK was decrypted, its length must agree with algorithm specification."
                 * If this is not the case, it either means ciphertext was tampered
                 * with or the keyring implementation is not setting the length properly.
                 */

                return _context2.abrupt("return", material);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onDecrypt(_x2, _x3) {
        return _onDecrypt.apply(this, arguments);
      }

      return onDecrypt;
    }()
  }]);

  return Keyring;
}();
immutableBaseClass(Keyring);
export var KeyringNode = /*#__PURE__*/function (_Keyring) {
  _inherits(KeyringNode, _Keyring);

  var _super = _createSuper(KeyringNode);

  function KeyringNode() {
    _classCallCheck(this, KeyringNode);

    return _super.apply(this, arguments);
  }

  return KeyringNode;
}(Keyring);
immutableClass(KeyringNode);
export var KeyringWebCrypto = /*#__PURE__*/function (_Keyring2) {
  _inherits(KeyringWebCrypto, _Keyring2);

  var _super2 = _createSuper(KeyringWebCrypto);

  function KeyringWebCrypto() {
    _classCallCheck(this, KeyringWebCrypto);

    return _super2.apply(this, arguments);
  }

  return KeyringWebCrypto;
}(Keyring);
immutableClass(KeyringWebCrypto);